const LIST = '/ecosoft'
const STOCK_LIST = '/ecosoft/stock/'
const FILTERS = '/ecosoft/filters/'

export const endpointsEcosoft = {
  LIST,
  STOCK_LIST,
  FILTERS,
}
